module.exports = __webpack_public_path__ + "static/RootSans-7SemiBold-e9d0e97fd6648a80db094e4fca28e850.woff";